function Menu() {
  const $document = $(document);
  const $body = $('body');

  const $menu = $document.find('.header-menu');
  const $mainHeader = $document.find('.main-header');
  const $firstMenuLevel = $menu.find('.menu-level-1');

  const init = () => {
    MenuMobile();
    MenuDesktop();
  };

  const MenuMobile = () => {
    const $mainHeaderContainer = $document.find('.main-header-container');
    const $menuMobileBtn = $document.find('.btn-toogle-menu-mob');
    const $closeBtn = $('.close-menu-mob');

    const init = () => {
      toogleMenu();
      subMenu();
      $document.on('widgetHeaderMobClose', () => closeMenu());
    };

    const closeMenu = () => {
      $body.removeClass('offcanvas-opened menu-mobile-opened');
      $mainHeaderContainer.removeClass('active');
      $mainHeader.removeClass('sub-menu-opened');
      $menu.find('.header-submenu.active').removeClass('active');
    };

    const toogleMenu = () => {
      $menuMobileBtn.on('click', () => {
        $body.addClass('offcanvas-opened menu-mobile-opened');
        $mainHeaderContainer.addClass('active');
      });

      $closeBtn.on('click', closeMenu);
    };

    const subMenu = () => {
      const $headerMobileBackBtn = $document.find('.header-mobile-back-btn');

      $firstMenuLevel.on('click', (e) => {
        const $e = $(e.currentTarget);
        const $sub = $e.next('.header-submenu');

        if (!$sub.length) return;

        $mainHeader.addClass('sub-menu-opened');
        $sub.addClass('active');
      });

      $headerMobileBackBtn.on('click', () => {
        $mainHeader.removeClass('sub-menu-opened');
        $menu.find('.header-submenu.active').removeClass('active');
      });
    };

    init();
  };

  const MenuDesktop = () => {
    const $subMenu = $menu.find('.header-menu-list-item');
    $subMenu.on('hover', (e) => {
      $(e.target).find('.header-submenu').addClass('already-opened');
    });
  }

  init();
}

window.aguadecoco = window.aguadecoco || {};

Object.assign(window.aguadecoco, {
  widgets: Object.assign(window.aguadecoco.widgets || {}, {
    search: new Menu(),
  }),
});

export default {};
